import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import './SettingStyles.css';
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import DOMPurify from 'dompurify';
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import ProfileSetting from "./ProfileSetting";
import HelpAndSupport from "./HelpAndSupport";
import DeliverySettings from "./DeliverySettings";
import CartButtonOptions from "./CartButtonOptions";
import PaymentButtonOptions from "./PaymentButtonOptions";
import GstInlineSetting from "./GstSetting";
import GuestSetting from "./GuestSetting";
import MetaDetails from "./MetaDetails";
import Loader from "../Loader";
import PaymentGateway from "./PaymentGateway";
import LoginPass from "./LoginPass";
import LoginBanner from "./LoginBanner";
import TwoStepVerification from "./TwoStepVerification";
import { decryptToken } from "../utils/getToken";


const tabList = [
    "Profile Information",
    "Help & Support Contacts",
    "Delivery Settings (Cash Before Pay + Free Delivery)",
    "Cart Button Options",
    "Payment Button Options",
    "GST Configuration",
    "Meta Details",
    "Guest Settings (Restaurant Only)",
    "Payment Gateway (Razorpay)",
    "Login Mail & Passkey",
    //  "Login Banner"
    "2-Step Verification",
];

const SettingUpdated = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    console.log(isLoggedIn)
    const [userData, setUserData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editMode1, setEditMode1] = useState(false);
    const [editMode1cart, setEditMode1cart] = useState(false);
    const [formData, setFormData] = useState({});
    const [help, setHelp] = useState({})
    const [Emailpass, setEmailPass] = useState({})
    const [userDatahelp, setUserDatahelp] = useState(null);
    const [Emailpasshelp, setEmailpasshelp] = useState(null);
    const [useTextLogo, setUseTextLogo] = useState(false);
    const { isSidebarOpen } = useSidebar();
    const [deliveryPayData, setDeliveryPayData] = useState({});
    const [editDelivery, setEditDelivery] = useState(false);
    const autocompleteRef = useRef(null);
    const [deliveryRanges, setDeliveryRanges] = useState([]);
    const [newRange, setNewRange] = useState([{ price: "", min_km: "", max_km: "" }]);
    const [editId, setEditId] = useState(null);
    const [submittedRanges, setSubmittedRanges] = useState([]);
    const [cartButtons, setCartButtons] = useState([]);
    const [editButtonData, setEditButtonData] = useState(null); // for modal editing
    const [payButtons, setPayButtons] = useState([]);
    const [editpayButtonData, setpayEditButtonData] = useState(null); // for modal editing
    const [gstData, setGstData] = useState({ gstPercent: "" });
    const [editGst, setEditGst] = useState(false);
    const [guestData, setGuestData] = useState({ totalminimum: "" });
    const [editGuest, setEditGuest] = useState(false);
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ["places"],
    });
    const [originalFormData, setOriginalFormData] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);
    const [meta, setMeta] = useState({});
    const [userMetaData, setUserMetaData] = useState(null);
    const [loading, setLoading] = useState(false)
    const [razorpayData, setRazorpayData] = useState({ key_id: "", key_secret: "", company_color: "", company_name: "" });
    const [editPayment, setEditPayment] = useState(false);
    const [enabled, setEnabled] = useState(false);


    useEffect(() => {
        if (!originalFormData) return;
        const hasDiff = JSON.stringify(formData) !== JSON.stringify(originalFormData);
        setHasChanges(hasDiff);
    }, [formData, originalFormData]);

    const token = decryptToken("accessToken") || ""
    console.log(token)

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",

                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            const res = await response.json();
            setUserData(res.users);
            setFormData(res.users);
            setOriginalFormData(res.users);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchHelpuser = async () => {
        try {
            const response = await fetch(`${url}/help/single/${isLoggedIn.main_id}`);
            const res = await response.json();

            console.log(res.help)
            setUserDatahelp(res.help);
            setHelp(res.help);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchEmailpassuser = async () => {
        try {
            const response = await fetch(`${url}/login-cred/${isLoggedIn.main_id}`);
            const res = await response.json();

            console.log(res)
            setEmailpasshelp(res);
            setEmailPass(res);
        } catch (error) {
            console.log(error);
        }
    };
    const extractSrc = (input) => {
        if (typeof input !== "string") return "";
        const match = input.match(/src=["'](.*?)["']/);
        return match?.[1] || input.trim();
    };

    const fetchMetaData = async () => {
        try {
            const response = await fetch(`${url}/meta/${isLoggedIn.main_id}`);
            const res = await response.json();

            if (!res.isError) {
                let scripts = [];

                // case 1: Array of strings
                if (Array.isArray(res.data.scripts)) {
                    scripts = res.data.scripts.map((s) => {
                        if (!s) return "";
                        if (typeof s !== "string") return "";
                        const match = s.match(/src=["'](.*?)["']/);
                        return match?.[1] || s.trim();  // keep raw if no src
                    });
                }

                // case 2: Stringified JSON
                else if (typeof res.data.scripts === "string") {
                    try {
                        const parsed = JSON.parse(res.data.scripts);
                        if (Array.isArray(parsed)) {
                            scripts = parsed.map((s) => {
                                if (typeof s !== "string") return "";
                                const match = s.match(/src=["'](.*?)["']/);
                                return match?.[1] || s.trim();
                            });
                        }
                    } catch (err) {
                        console.warn("Script JSON parse error", err);
                    }
                }

                const cleanMeta = {
                    ...res.data,
                    scripts: scripts,
                };

                console.log(cleanMeta);
                setUserMetaData(cleanMeta);  // for display
                setMeta(cleanMeta);          // for editing
            }
        } catch (error) {
            console.error("Meta fetch error:", error);
        }
    };




    const addDeliveryRange = () => {
        setNewRange([...newRange, { price: "", min_km: "", max_km: "" }]);
    };

    const updateDeliveryRange = (index, field, value) => {
        const updatedRanges = [...newRange];
        updatedRanges[index][field] = value;
        setNewRange(updatedRanges);
    };

    const saveEdit = async (id) => {
        const updated = deliveryRanges.find(r => r.id === id);
        const res = await fetch(`${url}/freedelivery/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updated),
        });
        const result = await res.json();
        if (!res.ok) return toast.error("Update failed");

        setEditId(null);
    };


    const submitDeliveryRanges = async () => {
        try {
            if (newRange.length > 1) {
                for (let i = 0; i < newRange.length; i++) {
                    const { price, min_km, max_km } = newRange[i];

                    if (!price || !min_km || !max_km) {
                        toast.error(`All fields must be filled at row ${i + 1}`);
                        return;
                    }
                }
            }

            // Submit all filled rows (can skip empty if needed)
            for (let i = 0; i < newRange.length; i++) {
                const { price, min_km, max_km } = newRange[i];

                // Skip empty row if it's the only one
                if (!price && !min_km && !max_km && newRange.length === 1) {
                    continue;
                }

                const res = await fetch(`${url}/freedelivery`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        min_kilometer: min_km,
                        max_kilometer: max_km,
                        freedelivery_price: price,
                        status: 1,
                        user_id: userData.main_id,
                        user_name: userData.full_name,
                    }),
                });

                const result = await res.json();

                if (!res.ok) {
                    throw new Error(result.message || "Submission failed");
                }
            }

            setSubmittedRanges([...newRange]);
            setNewRange([{ price: "", min_km: "", max_km: "" }]);
            toast.success("Free delivery ranges submitted successfully!");
        } catch (error) {
            console.error("Error submitting:", error);
            toast.error("Error: " + error.message);
        }
    };



    const fetchDeliveryPayData = async () => {
        try {
            const response = await fetch(`${url}/deliverypaybefore/single/${isLoggedIn.main_id}`);
            const res = await response.json();
            setDeliveryPayData(res.help || {}); // similar to help structure
        } catch (error) {
            console.error("Error fetching delivery data:", error);
        }
    };

    const fetchGSTData = async () => {
        try {
            const res = await fetch(`${url}/gst/${isLoggedIn.main_id}`);
            const data = await res.json();
            if (res.ok) {
                setGstData(data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };

    const handlePayrazorSubmit = async () => {
        try {
            const res = await fetch(`${url}/pay-razorpay`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                    key_id: razorpayData.key_id,
                    key_secret: razorpayData.key_secret,
                    company_color: razorpayData.company_color,
                    company_name: razorpayData.company_name
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("Payment Gateway saved successfully");
                fetchPaymentrazData();
                setEditPayment(false);
            } else {
                toast.error(result.message || "Failed to save Guest");
            }
        } catch (error) {
            console.error("Guest save error:", error);
            toast.error("Error saving Guest");
        }
    };

    useEffect(() => {
        fetchSingleuser();
        fetchHelpuser();
        fetchDeliveryPayData();
        fetchGSTData();
        fetchMetaData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleGstChange = (e) => {
        setGstData({ ...gstData, gstPercent: e.target.value });
    };


    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, profilePic: file, orignal_logoname: null });
    };

    const handlePlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();
        if (place && place.formatted_address) {
            setFormData((prev) => ({
                ...prev,
                google_address: place.formatted_address,
            }));
        }
    };

    const handleTextLogoChange = (e) => {
        setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
    };

    const handleMetaSubmit = async (customData, iconFile) => {
        try {
            const form = new FormData();
            const data = customData || help;
            console.log(iconFile)
            for (const key in data) {
                if (key === "scripts") {
                    form.append("scripts", JSON.stringify(data[key] || []));
                } else if (key !== "iconFile" && data[key] !== undefined && data[key] !== null) {
                    form.append(key, data[key]);
                }
            }
            if (iconFile) {
                form.append("icon", iconFile);
            }

            form.append("user_id", String(isLoggedIn.main_id));
            form.append("user_name", String(isLoggedIn.full_name));


            const method = userMetaData ? "PUT" : "POST";
            const endpoint = userMetaData
                ? `${url}/meta/${isLoggedIn.main_id}`
                : `${url}/meta`;

            const res = await fetch(endpoint, {
                method,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,
            });

            // ✅ Validate response type
            // const contentType = res.headers.get("content-type");
            // if (!contentType || !contentType.includes("application/json")) {
            //     const raw = await res.text();
            //     console.error("Received non-JSON:", raw);
            //     throw new Error("Server response was not JSON");
            // }

            const result = await res.json();


            if (res.ok) {
                toast.success("Meta info saved successfully");
                fetchMetaData();

            } else {
                toast.error(result.message || "Failed to save meta info");
            }
        } catch (error) {
            console.error("Meta save error:", error);
            toast.error("Error saving meta info");
        }
    };


    const handleSubmit = async () => {
        const form = new FormData();
        for (let key in formData) {
            if (formData[key] !== null) form.append(key, formData[key]);
        }

        try {
            const res = await fetch(`${url}/register/change/${isLoggedIn.main_id}`, {
                method: "PUT",
                mode: "cors",
                credentials: "include",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: form,

            });
            const data = await res.json();
            console.log(data)
            toast.success("Profile updated successfully");
            setEditMode(false);
            fetchSingleuser();
        } catch (err) {
            console.error("Update error:", err);
        }
    };

    const handleHelpSubmit = async () => {
        try {
            const method = userDatahelp ? "PUT" : "POST";
            const endpoint = userDatahelp
                ? `${url}/help/${isLoggedIn.main_id}`
                : `${url}/help`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...help,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name
                }),
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(`Help info ${userDatahelp ? "updated" : "created"} successfully`);
                setUserDatahelp(help);
                setEditMode1(false);
            } else {
                toast.error(result.message || "Failed to save help info");
            }
        } catch (error) {
            console.error("Help save error:", error);
            toast.error("Error saving help info");
        }
    };

    const handleEmailpassSubmit = async () => {
        try {
            const method = "POST";
            const endpoint = `${url}/login-cred`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...Emailpass,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name
                }),
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(`Details saved successfully`);
                setUserDatahelp(help);
                setEditMode1(false);
            } else {
                toast.error(result.message || "Failed to save help info");
            }
        } catch (error) {
            console.error("Help save error:", error);
            toast.error("Error saving help info");
        }
    };

    const handleDeliveryPaySubmit = async () => {
        try {
            const method = deliveryPayData?.id ? "PUT" : "POST";
            const endpoint = deliveryPayData?.id
                ? `${url}/deliverypaybefore/${isLoggedIn.main_id}`
                : `${url}/deliverypaybefore`;

            const response = await fetch(endpoint, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    ...deliveryPayData,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                }),
            });

            const result = await response.json();
            if (response.ok) {
                toast.success(`Delivery policy ${method === "POST" ? "created" : "updated"} successfully`);
                setEditDelivery(false);
                fetchDeliveryPayData();
            } else {
                toast.error(result.message || "Failed to save delivery policy");
            }
        } catch (error) {
            toast.error("Error saving delivery policy");
            console.error(error);
        }
    };

    useEffect(() => {
        if (editMode && window.google && autocompleteRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(autocompleteRef.current, {
                types: ["geocode"],
                componentRestrictions: { country: "in" }, // Optional: restrict to India
            });

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (place.formatted_address) {
                    setFormData((prev) => ({
                        ...prev,
                        google_address: place.formatted_address,
                    }));
                }
            });
        }
    }, [editMode]);

    const deleteRange = async (id) => {
        if (!window.confirm("Delete this range?")) return;
        const res = await fetch(`${url}/freedelivery/${id}`, { method: "DELETE" });
        const result = await res.json();
        if (!res.ok) return toast.error("Delete failed");

        setDeliveryRanges(prev => prev.filter(r => r.id !== id));
    };


    // useEffect(() => {
    //     fetch(`${url}/freedelivery/${isLoggedIn.main_id}`)
    //         .then(res => res.json())
    //         .then(data => {
    //             if (!data.isError) {
    //                 setDeliveryRanges(data.data);
    //             }
    //         });
    // }, []);


    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchSingleuser(),
                    fetchHelpuser(),
                    fetchDeliveryPayData(),
                    fetchGSTData(),
                    fetchMetaData(),
                    cartOption(),
                    paymentOption(),
                    fetchGUESTData(),
                    fetch(`${url}/freedelivery/${isLoggedIn.main_id}`)
                        .then(res => res.json())
                        .then(data => {
                            if (!data.isError) setDeliveryRanges(data.data);
                        })
                ]);
            } catch (error) {
                console.error("Error loading data:", error);
                toast.error("Error loading settings");
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);


    const removeDeliveryRange = (index) => {
        setNewRange((prev) => prev.filter((_, i) => i !== index));
    };

    const cartOption = async () => {
        try {
            const response = await fetch(`${url}/button/${isLoggedIn.main_id}`)
            const res = await response.json();
            console.log(res.data);
            setCartButtons(res.data);
        } catch (error) {
            console.log(error)
        }
    }

    const paymentOption = async () => {
        try {
            const response = await fetch(`${url}/paybutton/${isLoggedIn.main_id}`)
            const res = await response.json();
            console.log(res.data);
            setPayButtons(res.data);
        } catch (error) {
            console.log(error)
        }
    }


    const handleSaveEdit = async () => {
        const { id, button_id, button, default: isDefault } = editButtonData;

        try {
            // Base update
            const updates = [{ id, button, default: isDefault }];

            // Apply rule:
            if (isDefault) {
                if (button_id === "getquote") {
                    // If "Get Quote" is set to default, unset "addtocart" and "buynow"
                    cartButtons.forEach(b => {
                        if ((b.button_id === "addtocart" || b.button_id === "buynow") && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                } else {
                    // If "addtocart" or "buynow" is set to default AND getquote is true, unset getquote
                    cartButtons.forEach(b => {
                        if (b.button_id === "getquote" && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                }
            }

            // Send batch update
            const response = await fetch(`${url}/button/api/update-cart-buttons`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
            });

            const result = await response.json();

            if (!result.isError) {
                // Update frontend
                const updated = cartButtons.map(btn => {
                    const found = updates.find(u => u.id === btn.id);
                    return found ? { ...btn, ...found } : btn;
                });
                setCartButtons(updated);
                setEditButtonData(null);
            } else {
                toast.error("Failed to update");
            }

        } catch (err) {
            console.error(err);
            toast.error("Error occurred");
        }
    };


    const handleSavePaymentEdit = async () => {
        const { id, button_id, button, default: isDefault } = editpayButtonData;

        try {
            // Base update
            const updates = [{ id, button, default: isDefault }];

            // Apply rule:
            if (isDefault) {
                if (button_id === "paymanual") {
                    // If "Get Quote" is set to default, unset "addtocart" and "buynow"
                    payButtons.forEach(b => {
                        if ((b.button_id === "paynow" || b.button_id === "payondelivery") && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                } else {
                    // If "addtocart" or "buynow" is set to default AND getquote is true, unset getquote
                    payButtons.forEach(b => {
                        if (b.button_id === "paymanual" && b.default) {
                            updates.push({ id: b.id, default: false });
                        }
                    });
                }
            }

            // Send batch update
            const response = await fetch(`${url}/paybutton/api/update-cart-buttons`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
            });

            const result = await response.json();

            if (!result.isError) {
                // Update frontend
                const updated = payButtons.map(btn => {
                    const found = updates.find(u => u.id === btn.id);
                    return found ? { ...btn, ...found } : btn;
                });
                setPayButtons(updated);
                setpayEditButtonData(null);
            } else {
                toast.error("Failed to update");
            }

        } catch (err) {
            console.error(err);
            toast.error("Error occurred");
        }
    };

    const handleGstSubmit = async () => {
        try {
            const res = await fetch(`${url}/gst`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                    gstPercent: gstData.gstPercent,
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("GST saved successfully");
                fetchGSTData();
                setEditGst(false);
            } else {
                toast.error(result.message || "Failed to save GST");
            }
        } catch (error) {
            console.error("GST save error:", error);
            toast.error("Error saving GST");
        }
    };

    // console.log(help)

    const handleGuestChange = (e) => {
        setGuestData({ ...guestData, totalminimum: e.target.value });
    };

    const handleGuestSubmit = async () => {
        try {
            const res = await fetch(`${url}/guest-total`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name,
                    totalminimum: guestData.totalminimum,
                }),
            });
            const result = await res.json();
            if (res.ok) {
                toast.success("Guest saved successfully");
                fetchGUESTData();
                setEditGuest(false);
            } else {
                toast.error(result.message || "Failed to save Guest");
            }
        } catch (error) {
            console.error("Guest save error:", error);
            toast.error("Error saving Guest");
        }
    };

    const fetchGUESTData = async () => {
        try {
            const res = await fetch(`${url}/guest-total/${isLoggedIn.main_id}`);
            const data = await res.json();
            if (res.ok) {
                setGuestData(data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };


    const fetchPaymentrazData = async () => {
        try {
            const res = await fetch(`${url}/pay-razorpay/${isLoggedIn.main_id}`);
            const data = await res.json();
            if (res.ok) {
                setRazorpayData(data);
            }
        } catch (error) {
            console.error("Failed to fetch GST data", error);
        }
    };

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch(`${url}/two-step/status/${isLoggedIn.main_id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                const res = await response.json();
                if (response.ok) {
                    setEnabled(res.verify); // set toggle based on backend
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchStatus();
    }, []);


    useEffect(() => {
        fetchEmailpassuser();
        fetchPaymentrazData();
        cartOption();
        paymentOption();
        fetchGUESTData();
    }, [])

    if (!userData) return <p className="hbtecom-loading">Loading...</p>;


    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleCombinedSubmit = async () => {
        // ✅ Only validate if more than one row
        if (newRange.length > 1) {
            const incompleteRows = newRange.filter(
                (r) =>
                    !r.min_km?.toString().trim() ||
                    !r.max_km?.toString().trim() ||
                    !r.price?.toString().trim()
            );

            if (incompleteRows.length > 0) {
                toast.error("Please fill all fields in each delivery range row.");
                return; // prevent submission
            }
        }

        try {
            await handleDeliveryPaySubmit();   // Save delivery percent
            await submitDeliveryRanges();      // Save new ranges
            toast.success("Delivery settings updated.");
        } catch (error) {
            toast.error("Error saving delivery settings.");
            console.error(error);
        }
    };



    if (loading) {
        return (
            <Loader />
        );
    }


    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <motion.div
                className="admin-accordion-container"
                layout
                transition={{ layout: { duration: 0.4, ease: "easeInOut" } }}
            >
                <h2 className="admin-accordion-heading">Settings Configuration</h2>

                {tabList.map((item, index) => {
                    if (index === 7 && isLoggedIn?.category !== "Restaurant") {
                        return null;
                    }

                    return <motion.div key={index} className="admin-accordion-item" layout>

                        <button
                            className="admin-accordion-header"
                            onClick={() => toggleAccordion(index)}
                        >
                            <span>{item}</span>
                            {activeIndex === index ? <><ChevronUp size={20} /></> : <><ChevronDown size={20} /></>}
                        </button>
                        <AnimatePresence initial={false}>
                            {activeIndex === index && (
                                <motion.div
                                    className="admin-accordion-content"
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    style={{ overflow: "hidden" }}
                                >
                                    {index === 0 && (
                                        <div>
                                            <ProfileSetting
                                                formData={formData}
                                                handleChange={handleChange}
                                                useTextLogo={useTextLogo}
                                                setUseTextLogo={setUseTextLogo}
                                                handleLogoChange={handleLogoChange}
                                                handleTextLogoChange={handleTextLogoChange}
                                                isLoaded={isLoaded}
                                                Autocomplete={Autocomplete}
                                                autocompleteRef={autocompleteRef}
                                                handlePlaceChanged={handlePlaceChanged}
                                                ReactQuill={ReactQuill}
                                                setFormData={setFormData}
                                                originalFormData={originalFormData}
                                                handleSubmit={handleSubmit}
                                            />
                                        </div>
                                    )}

                                    {index === 1 && (
                                        <HelpAndSupport
                                            helpData={help}
                                            setHelpData={setHelp}
                                            originalHelpData={userDatahelp}
                                            handleHelpSubmit={handleHelpSubmit}
                                        />
                                    )}

                                    {index === 2 && (
                                        <DeliverySettings
                                            deliveryPayData={deliveryPayData}
                                            setDeliveryPayData={setDeliveryPayData}
                                            newRange={newRange}
                                            setNewRange={setNewRange}
                                            handleCombinedSubmit={handleCombinedSubmit}
                                            deliveryRanges={deliveryRanges}
                                            deleteRange={deleteRange}
                                        />

                                    )}

                                    {index === 3 && (
                                        <CartButtonOptions
                                            cartButtons={cartButtons}
                                            editButtonData={editButtonData}
                                            setEditButtonData={setEditButtonData}
                                            handleSaveEdit={handleSaveEdit}
                                        />
                                    )}

                                    {index === 4 && (
                                        <PaymentButtonOptions
                                            payButtons={payButtons}
                                            editpayButtonData={editpayButtonData}
                                            setpayEditButtonData={setpayEditButtonData}
                                            handleSavePaymentEdit={handleSavePaymentEdit}
                                        />
                                    )}

                                    {index === 5 && (
                                        <GstInlineSetting
                                            gstData={gstData}
                                            setGstData={setGstData}
                                            handleGstSubmit={async (updated) => {
                                                setGstData(updated); // optional, but for local update
                                                try {
                                                    const res = await fetch(`${url}/gst`, {
                                                        method: "POST",
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                            Authorization: `Bearer ${token}`,
                                                        },
                                                        body: JSON.stringify({
                                                            user_id: isLoggedIn.main_id,
                                                            user_name: isLoggedIn.full_name,
                                                            gstPercent: updated.gstPercent, // ✅ use updated value
                                                        }),
                                                    });

                                                    const result = await res.json();
                                                    if (res.ok) {
                                                        toast.success("GST saved successfully");
                                                        fetchGSTData(); // refresh data
                                                    } else {
                                                        toast.error(result.message || "Failed to save GST");
                                                    }
                                                } catch (error) {
                                                    console.error("GST save error:", error);
                                                    toast.error("Error saving GST");
                                                }
                                            }}
                                        />
                                    )}

                                    {index === 6 && (
                                        <MetaDetails
                                            helpData={meta}
                                            setHelpData={setMeta}
                                            originalHelpData={userMetaData}
                                            handleHelpSubmit={handleMetaSubmit}
                                        />
                                    )}


                                    {(index === 7 && isLoggedIn?.category?.toLowerCase() === "restaurant") ? <GuestSetting
                                        guestData={guestData}
                                        setGuestData={setGuestData}
                                        handleGuestSubmit={handleGuestSubmit}
                                    /> : (
                                        null
                                    )}
                                    {index === 8 && (
                                        <PaymentGateway
                                            guestData={razorpayData}
                                            setGuestData={setRazorpayData}
                                            handleGuestSubmit={handlePayrazorSubmit}
                                        />
                                    )}

                                    {index === 9 && (
                                        <LoginPass
                                            helpData={Emailpass}
                                            setHelpData={setEmailPass}
                                            originalHelpData={Emailpasshelp}
                                            handleHelpSubmit={handleEmailpassSubmit}
                                        />
                                    )}
                                    {index === 10 && (
                                        <TwoStepVerification
                                            enabled={enabled}
                                            setEnabled={setEnabled}

                                        />
                                    )}
                                    {/* {index === 10 && (
                                        <LoginBanner
                                            helpData={Emailpass}
                                            setHelpData={setEmailPass}
                                            originalHelpData={Emailpasshelp}
                                            handleHelpSubmit={handleEmailpassSubmit}
                                        />
                                    )} */}

                                </motion.div>
                            )}
                        </AnimatePresence>
                    </motion.div>
                })}

            </motion.div>
        </div >
    );
};

export default SettingUpdated;
